import { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialColumns, initialFilter } from "./GradeAndSectionReportUIHelpers";

const GradeAndSectionReportUIContext = createContext();

export function useGradeAndSectionReportUIContext() {
  return useContext(GradeAndSectionReportUIContext);
}

export const GradeAndSectionReportUIConsumer = GradeAndSectionReportUIContext.Consumer;

export function GradeAndSectionReportUIProvider({ children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [gradeLevelStyle, setGradeLevelStyle] = useState("success");
  const [gradeStyle, setGradeStyle] = useState("success");
  const [columns, setColumns] = useState(initialColumns);
  const [data, setData] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    gradeLevelStyle,
    setGradeLevelStyle,
    gradeStyle,
    setGradeStyle,
    columns,
    setColumns,
    data,
    setData,
    setQueryParams
  };

  return (
    <GradeAndSectionReportUIContext.Provider value={value}>
      {children}
    </GradeAndSectionReportUIContext.Provider>
  );
}